import Model, { attr, belongsTo } from '@ember-data/model';

export default class PrescreenerAnswerModel extends Model {
  @belongsTo('treatable-client', { polymorphic: true, async: false, inverse: null }) client;
  @belongsTo('prescreener-question', { async: false, inverse: null }) prescreenerQuestion;

  @attr() answers;
  @attr() files;
}
